import React from 'react';
import { TrainingShell } from '../components/TrainingV2';

const DataLiteracyTraining: React.FC = () => {
  return (
    <TrainingShell
      moduleId="data-literacy-fundamentals"
      moduleName="Data Literacy Fundamentals"
      backUrl="/learn101"
    />
  );
};

export default DataLiteracyTraining;
